import React, { useEffect, useState } from "react";
import { AlertTriangle, X, Info } from "lucide-react";
import api from "@/lib/api";

export function AnnouncementBanner() {
  const [anns, setAnns] = useState([]);
  const [dismissed, setDismissed] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem("dismissed_anns") || "[]"); } catch { return []; }
  });

  useEffect(() => {
    api.get("/announcements").then(({ data }) => setAnns(data)).catch(() => {});
  }, []);

  const visible = anns.filter((a) => (a.priority === "urgent" || a.priority === "high" || a.personal) && !dismissed.includes(a.id));
  if (!visible.length) return null;
  const a = visible[0];
  const urgent = a.priority === "urgent";

  const dismiss = () => {
    const next = [...dismissed, a.id];
    setDismissed(next);
    sessionStorage.setItem("dismissed_anns", JSON.stringify(next));
  };

  return (
    <div data-testid="announcement-banner"
      className={`relative px-4 py-3 text-sm ${urgent ? "bg-[#FEF2F2] text-[#991B1B] border-b-2 border-[#EF4444]" : "bg-[#FEF3C7] text-[#92600A] border-b border-[#D97706]/40"}`}>
      <div className="mx-auto flex max-w-7xl items-center gap-3 pr-8">
        {urgent ? <AlertTriangle size={18} className="shrink-0" /> : <Info size={18} className="shrink-0" />}
        <p><span className="font-bold">{a.title}</span>{a.message ? ` — ${a.message}` : ""}</p>
        <button onClick={dismiss} data-testid="dismiss-announcement" aria-label="Dismiss announcement"
          className="absolute right-3 top-1/2 -translate-y-1/2 rounded p-1 hover:bg-black/5"><X size={16} /></button>
      </div>
    </div>
  );
}
